import * as Colors from '@wandb/weave/common/css/color.styles';
import {TextField} from '@wandb/weave/components/Form/TextField';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {FixedSizeTextArea} from '../Form/FixedSizeTextArea';

export const DrawerContents = styled.div`
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';

export const SecretsDrawer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;
SecretsDrawer.displayName = 'S.SecretsDrawer';

export const SecretsDrawerMain = styled.div`
  flex: 1 1 auto;
  padding: 4px;
  padding-bottom: 300px;
  margin-top: 20px;
`;
SecretsDrawerMain.displayName = 'S.SecretsDrawerMain';

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  padding: 20px 0;
`;
Header.displayName = 'S.Header';

export const CloseButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
`;
CloseButton.displayName = 'S.CloseButton';

export const PageLabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
  font-weight: 600;
  color: ${Colors.MOON_500};
`;
PageLabelRow.displayName = 'S.PageLabelRow';

export const Description = styled.div`
  font-size: 16px;
  margin-bottom: 8px;
`;
Description.displayName = 'S.Description';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const Footer = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;
Footer.displayName = 'S.Footer';

export const FooterRightContent = styled.div`
  text-align: right;
  display: inline;
  min-width: 50px;
  flex: 1 0 50px;
  align-content: flex-end;
  vertical-align: middle;
`;
FooterRightContent.displayName = 'S.FooterRightContent';

export const FooterLeftContent = styled.div`
  text-align: right;
  display: inline;
  min-width: 50px;
  flex: 0 1 50px;
  align-content: flex-start;
  vertical-align: middle;
`;
FooterLeftContent.displayName = 'S.FooterLeftContent';

export const Divider = styled.div`
  background-color: ${Colors.MOON_250};
  height: 1px;
  margin-left: -20px;
  margin-right: -20px;
`;

export const StyledTextField = styled(TextField)`
  font-family: 'Source Sans Pro';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
StyledTextField.displayName = 'S.StyledTextField';

export const StyledTextArea = styled(FixedSizeTextArea)<{showSecret?: boolean}>`
  min-height: 80px;
  -webkit-text-security: ${props => (props.showSecret ? 'none' : 'disc')};
`;
StyledTextArea.displayName = 'S.StyledTextArea';

export const ErrorText = styled.div`
  color: ${Colors.RED_500};
  line-height: 24px;
  margin-top: 8px;
`;
ErrorText.displayName = 'S.ErrorText';

export const CodeStyle = styled.span`
  display: inline;
  background-color: ${Colors.MOON_600};
  font-family: Source Code Pro;
  padding: 1px 2px;
  border-radius: 4px;
  font-size: 14px;
  color: ${Colors.WHITE};
  line-height: normal;
  margin-left: 0.4em;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;
CodeStyle.displayName = 'S.CodeStyle';
